import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import qs from 'qs';
import { v4 as uuidv4 } from 'uuid';

import AuthWrapper from './common/AuthWrapper';
import InputWrapper from '../common/InputWrapper';
import Button from '../common/Button';

import { fetchSignIn, setAuthToken, setPrivileges } from '../../actions/auth';

import { preventSubmittingByEnter } from '../../helpers';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const SignInPage = (props) => {
  const { isThirdParty } = props;

  const { t } = useAutoTranslation();

  const validationSchema = Yup.object().shape({
    login: Yup.string().trim().required(t('Необходимое поле')).email(t('Невалидный email')),
    password: Yup.string().required(t('Необходимое поле')),
  });

  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [redirectData, setRedirectData] = useState(null);

  useEffect(() => {
    document.title = 'Кактус — Вход';
    if (isThirdParty && history.location.search) {
      const parsedQs = qs.parse(history.location.search.slice(1));
      if (parsedQs.redirect_uri) {
        setRedirectData(parsedQs);
      }
    }

    const keyDownHandler = (event) => {
      if (event.key === 'Enter') {
        handleSubmit();
      }
    };

    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      login: '',
      password: '',
    },
    onSubmit: async (values) => {
      setLoading(true);
      const { login, password } = values;
      const res = await dispatch(fetchSignIn({ login, password }, redirectData)).finally(() => {
        setLoading(false);
      });
      if (!redirectData && !isThirdParty) {
        localStorage.setItem('Kak2cTokenData', JSON.stringify({ access_token: res.access_token }));
        dispatch(setAuthToken({ access_token: res.access_token }));
        localStorage.setItem('Kak2cPrivileges', JSON.stringify(res.privileges));
        dispatch(setPrivileges(res.privileges));
      } else {
        let redirectUrl = `${redirectData.redirect_uri}?access_token=${
          res.access_token
        }&token_type=${res.token_type}&expires_in=${res.expires_in}&access_id=${uuidv4()}`;
        if (redirectData.state) {
          redirectUrl += `&state=${redirectData.state}`;
        }
        window.location.href = redirectUrl;
      }
    },
    validationSchema,
  });

  const { values, errors, submitCount, handleChange, handleSubmit, setFieldValue } = formik;

  return (
    <AuthWrapper>
      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <InputWrapper
            type="text"
            label={t('Email')}
            id="login"
            value={values.login.trim()}
            error={errors.login}
            showValidation={submitCount}
            onChange={handleChange}
            placeholder={t('Введите email')}
            testId="signInPageEmailInput"
          />
        </div>

        <div className="form-group mb-3">
          <InputWrapper
            type="password"
            label={t('Пароль')}
            id="password"
            value={values.password}
            error={errors.password}
            showValidation={submitCount}
            onChange={handleChange}
            placeholder={t('Введите пароль')}
            testId="signInPagePassInput"
          />
        </div>

        {/* {signIn.error && <ErrorBlock error={signIn.error} />} */}

        <div className="form-group mb-0 text-center">
          <Button
            type="submit"
            text={t('Войти')}
            loading={loading}
            disabled={loading}
            style={{ width: '100%' }}
            testId="signInPageSubmitButton"
          />
        </div>
      </form>
      <div className="text-center" style={{ marginTop: '15px' }}>
        <p>
          <Link to="/forgot" className="ml-1">
            {t('Забыли пароль')}?
          </Link>
        </p>
        <p className="text-50">
          {t('Нет аккаунта')}?{' '}
          <Link to="/sign_up" className="ml-1">
            {t('Регистрация')}
          </Link>
        </p>
      </div>
    </AuthWrapper>
  );
};

export default SignInPage;
